// for now it is used in dineout-cart, later will be add more functionality to use in food as well and will replace the ErrorWidget

// deps
import React, { memo } from "react";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

// styles
import {
    ErrorFooterContainer,
    ErrorFooterSubtextHeading,
    ErrorFooterSubtextSubtext,
    ErrorFooterHeadingWrapper,
} from "./styles";

interface IProps {
    heading: string;
    subtext: string;
    ctaText: string;
    onCTAClick: () => void;
    errorIcon?: {
        cloudinaryId: string;
        width: string;
        height: string;
    };
}

const ErrorFooterWidget = (payload: IProps): React.ReactElement => {
    const { heading, subtext, ctaText, onCTAClick, errorIcon } = payload;
    return (
        <ErrorFooterContainer data-testid="error-footer-container">
            <ErrorFooterHeadingWrapper>
                <Image {...errorIcon} />

                <div>
                    <ErrorFooterSubtextHeading variant="V2.body1.neutral.bold">{heading}</ErrorFooterSubtextHeading>
                    <ErrorFooterSubtextSubtext variant="V2.body3.neutral.regular">{subtext}</ErrorFooterSubtextSubtext>
                </div>
            </ErrorFooterHeadingWrapper>
            <FullWidthButton variant="primary" onClick={onCTAClick} data-testid="error-footer-remove-cta-button">
                {ctaText}
            </FullWidthButton>
        </ErrorFooterContainer>
    );
};

export default memo(ErrorFooterWidget);
